define('Responsive/delegates/ScrollViewDelegate',['require','exports','module','../vendor','../util/dom','../util/extend','message-service/message-service','iscroll/build/iscroll'],function(require,exports,module){
    var ReVendor = require( '../vendor' ),
        ReDom    = require( '../util/dom' ),
        ReExtend = require( '../util/extend'),
        messageService = require('message-service/message-service');

    var iScroll = require( 'iscroll/build/iscroll' );
    // We should support stubbing iScroll out of a build
    // through a require config.  This makes it bit safer.
    if(iScroll && !iScroll.destroy){
        iScroll=function(scroller){ 
            this.destroy=function(){};return false;
        };
    } else {
        iScroll=window.IScroll||window.iScroll;
    }

    var optionsMap = {
            containerClass : [ 'scrollClass' ],
            vertical    : [ 'vScrollbar', 'scrollY' ],
            horizontal  : [ 'hScrollbar', 'scrollX' ],
            useGPU      : [ 'useTransition', 'HWCompositing' ],
            bounce      : [ 'bounce' ],
            momentum    : [ 'momentum' ],
            autoHideScrollbars : [ 'hideScrollbar', 'fadeScrollbars' ],
            scrollbars  : [ 'scrollbars' ],
            startX           : [ 'x', 'startX' ],
            startY           : [ 'y', 'startY' ]
        },
        //overflow-scroll is a mess... just ignore it
        supportsNativeScroll= false, //!ReVendor.isAndroid && ReVendor.check('overflow-scrolling'),
        reAllowDefault = /SELECT|INPUT|TEXTAREA/,
        allowDefaultTouch = function (e) {

            var target = e.target;
            while (target.nodeType != 1){
                target = target.parentNode;
            }

            if (!reAllowDefault.test(target.tagName)){
                e.preventDefault();
            }else{
                e.stopImmediatePropagation();
                return true;
            }
        };

    function ScrollViewDelegate(){
        this.control=null;

        this.options = {};
        this.publishers = {};
        messageService.bind(this);

        this.usableOptions = {
            bindToWrapper       : true,
            mouseWheel          : true,
            interactiveScrollbars : true,
            onBeforeScrollStart : allowDefaultTouch
        };
    }

    ScrollViewDelegate.prototype={
        createScroll : supportsNativeScroll ? function(scroller){
                scroller.style.position = 'relative';
                ReDom.setClassName(scroller,'is-native-on');
                ReDom.setClassName(scroller.children[0],'ScrollViewWrapper is-native');
                if(this.options.vertical===false || this.options.horizontal===true){
                    scroller.style.overflowX="auto";
                }
                this.control=null;
                return this.control;
            } : function(scroller,opts){
                var that=this;

                this.resetControl();
                scroller.style.position = 'relative';
                ReDom.setClassName(scroller,'is-iscroll');
                this.scroller=scroller;
                this.scrollerEl=scroller.children[0];
                this.scrollerElStyle=this.scrollerEl.style.cssText;
                this.control=new iScroll(scroller,this.usableOptions);
                ReDom.setClassName(this.control.scroller,'ScrollViewWrapper');
                
                this.manageScrollEvent('scrollEnd');
                
                // No one asked you to resize damnit.
                // I feel a little uneasy about this, but i'd like to control
                // refresh manually.
                this.control._resize=function(){};
                return this.control;
        },
        
        manageScrollEvent : function(evt){
            var that=this;

            if(this.publishers[evt]){
                return;
            }
            var pub = this.publishers[evt] = function(data){
                that.publish(evt,data);
            };

            if(this.control){
                if(this.control.on){
                    this.control.on(evt,pub);
                } else {
                    this.control.options.scrollEnd(pub);
                }
            } else{
                this.scroller.addEventListener(evt,pub,true,true);
            }
        },

        refreshControl : function(){
            if(this.control && this.control.refresh){
                this.control.refresh();
            }
        },
        resetControl   : function(){
            if(this.scroller){
                var scroller=this.scroller;
                ReDom.removeStyleProperty(scroller,'maxHeight');             
                ReDom.removeStyleProperty(scroller,'minHeight');             
                ReDom.removeStyleProperty(scroller,'minWidth');             
                ReDom.removeStyleProperty(scroller,'maxWidth');
                ReDom.removeStyleProperty(scroller,'position'); 
                ReDom.setClassName(scroller,'','is-iscroll');
                if(this.control){
                    ReDom.setClassName(this.control.scroller,'ScrollViewWrapper');
                }

                if(supportsNativeScroll){
                    ReDom.removeStyleProperty(scroller,'overflow-x');
                    ReDom.removeStyleProperty(scroller,'overflow-y'); 
                }
                this.scrollerEl.style.cssText=this.scrollerElStyle;
            }
            
            for(var key in this.publishers){
                this.off(key,this.publishers[key]);
                delete this.publishers[key];
            }


            /*
             * If there's a control and the control has something to destroy,
             * only then should you destroy it.
             * - Unknown
             */
            if(this.control && this.control.wrapper.children.length){
                this.control.destroy();
            }
            this.control=null;
            this.scroller=null;
            this.scrollerEl=null;
            this.scrollerElStyle=null;
        },

        config : function(opts){
            var i,
                key,
                len,
                mappedKeys;

            for(key in opts){
                this.options[key] = opts[key];
                mappedKeys=optionsMap[key]||[];
                len=mappedKeys.length;
                for(i=0; i<len; i++){
                    this.usableOptions[mappedKeys[i]]=opts[key];
                }
            }
        },

        getConfig : function(){
            return ReExtend({},this.options);
        },

        setScrollHeight : function(height,view,scroller,offsetParent, offsetParentView){
            var offset=0,
                adjustedHeight=height;
            if((this.control && this.control.vScroll===false) || this.options.vertical===false){

                ReDom.removeStyleProperty(scroller,'maxWidth');
                ReDom.removeStyleProperty(scroller,'minHeight');

                if(scroller && scroller.parentNode){

                    scroller.style.maxWidth=scroller.offsetWidth - scroller.offsetLeft + 'px';
                    if(!this.control){
                        this.createScroll(scroller);
                    }
                }
                return;
            }
            if(height==="auto" || !scroller){
                ReDom.removeStyleProperty(view,'maxHeight');
                ReDom.removeStyleProperty(view,'minHeight');
                if(this.control){
                    this.resetControl();
                }
            }else{
                ReDom.removeStyleProperty(view,'maxHeight');
                ReDom.removeStyleProperty(view,'minHeight');
                var mytop = scroller.getBoundingClientRect().top,
                    viewtop = view.getBoundingClientRect().top,
                    parentOffset;

                offset = (mytop - viewtop);
                if(offsetParent != offsetParentView && offsetParentView ){
                    parentOffset = offsetParentView.getBoundingClientRect().top;
                } else {
                    parentOffset = offsetParent.getBoundingClientRect().top;
                }
                offset += (viewtop - parentOffset);

                if(offset < 0 ){
                    offset = 0;
                }

                adjustedHeight= adjustedHeight - offset;
                // console.warn(scroller.className.replace(/^|\s+/g,"."),height,['offset:',offset,'top:',mytop,'viewtop:',viewtop,"parentOffset:",parentOffset]);

                scroller.style.maxHeight = scroller.style.minHeight=(adjustedHeight) + "px";

                if(!this.control){
                    this.createScroll(scroller);
                }else {
                    this.refreshControl();
                }
            }
            return adjustedHeight;
        },
        snapshot : function(){
            if(this.control){
                this.config({
                    startX : this.control.x,
                    startY : this.control.y
                });
            }
        }     
    };
    return ScrollViewDelegate;
});


